import { EntityNameModal } from '@/pages/admin/shared/entity-management/EntityNameModal';

type EditCategoryModalProps = {
	isOpen: boolean;
	onClose: () => void;
	initialName: string;
	initialDescription?: string | null;
	onSave: (payload: { name: string; description?: string }) => void;
};

export const EditCategoryModal = ({
	isOpen,
	onClose,
	initialName,
	initialDescription,
	onSave,
}: EditCategoryModalProps) => {
	return (
		<EntityNameModal
			isOpen={isOpen}
			onClose={onClose}
			title="Editar categoria"
			description="Atualize o nome da categoria."
			label="NOME DA CATEGORIA"
			placeholder="Ex: Bem-estar"
			submitText="Salvar alterações"
			inputId="form-edit-modal-cat-name"
			initialValue={initialName}
			descriptionFieldId="form-edit-modal-cat-description"
			descriptionFieldLabel="DESCRIÇÃO (OPCIONAL)"
			descriptionFieldPlaceholder="Ex: Perguntas sobre bem-estar e qualidade de vida no trabalho."
			initialDescriptionValue={initialDescription ?? ''}
			onSubmitValues={onSave}
		/>
	);
};
